<template>
  <div>
    <el-row>
      <el-col :span="22" :offset="1" style="background-color: rgba(100,100,100,0.1); padding: 20px; border-radius: 5px">
        <el-row style="font-size: 1.2em; font-weight: bold; margin-bottom: 20px">
          Clade Colors
        </el-row>
        <el-row :gutter="20">
          <el-col v-for="(lineage,idx) in store.datasets.selectedPangolinLineages"
            :key="idx" align="center" style="width: 220px; margin-bottom: 10px">
              <el-row>
                <el-col :span="12" id="clade-color-picker-label"
                  :style="`border: 2px solid ${store.theme.colors.pangolin_lineages[lineage]}`">
                  <b>{{ lineage }}</b>
                </el-col>
                <el-col :span="12" align="left">
                  <el-color-picker size="mini"  
                    v-model="store.theme.colors.pangolin_lineages[lineage]" 
                    @change="store.events.trigger+=1"
                    id="clade-color-picker"
                  >
                  </el-color-picker>
                </el-col>
              </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row style="margin-top: 10px">
      <el-col :span="22" :offset="1" align="right">
        <el-button type="primary" @click="cladeColorDefault">Reset defaults</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { store } from '@/scripts/store.js';
  const _ = require('lodash');
  
  export default {
    name: 'SettingsPanel',
    props: { },
    components: { },
    data() {
      
      return {
        store: store, 
      }
    },
    computed: {
    },
    created() {
    },
    destroyed() {
    },
    methods: {
      cladeColorDefault() {
        store.methods.cladeColorDefault();
      },
      lineageColorChange(lineage) {
        console.log(store.theme.colors.pangolin_lineages)
      }
    }
  }
</script>

<style>

#clade-color-picker .el-color-picker__trigger {
  padding: 0px;
  height: 40px;
  width: 50px;
  border: none;
  border-radius: 5px;
}

#clade-color-picker .el-color-picker__trigger .el-color-picker__color {
  border: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0px;
}

#clade-color-picker .el-color-picker__trigger .el-color-picker__color .el-color-picker__color-inner {
  border: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0px;
}

#clade-color-picker-label {
  height: 40px;
  padding-top: 8px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>